import { useMutation, useQueryClient } from "@tanstack/react-query";
import queryKeys from "../constants/queryKeys";
import documentService from "../services/documentService";

interface DeleteAccountFileVariables {
    formData: FormData;
    documentType: number;
}

const useDeleteAccountFile = () => {
    const queryClient = useQueryClient();
    return useMutation<unknown, Error, DeleteAccountFileVariables>({
        mutationFn: ({ formData, documentType }) =>
            documentService.deleteAccountFile(formData, documentType),
        onSuccess: () =>
            queryClient.invalidateQueries({ queryKey: [queryKeys.accountFiles] }),
    });
};

export default useDeleteAccountFile;
